import React from 'react';

const Partnership = () => {
  const benefits = [
    {
      icon: 'fa-money-bill-wave',
      title: 'Pendapatan Stabil',
      description: 'Jaminan pembelian dengan harga yang adil'
    },
    {
      icon: 'fa-graduation-cap',
      title: 'Pelatihan Rutin',
      description: 'Program edukasi dan pengembangan skill'
    },
    {
      icon: 'fa-tools',
      title: 'Bantuan Teknis',
      description: 'Dukungan teknologi dan peralatan modern'
    },
    {
      icon: 'fa-network-wired',
      title: 'Akses Pasar',
      description: 'Jaringan distribusi yang luas'
    }
  ];

  return (
    <section id="partnership" className="pt-20 sm:pt-24 pb-16 sm:pb-20 bg-light-bg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center bg-accent/20 text-primary px-3 py-2 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4">
            <i className="fa-solid fa-handshake mr-2"></i>
            Program Kemitraan
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4 sm:mb-6">
            Bergabung Sebagai<br className="hidden sm:block"/>
            <span className="text-secondary">Mitra PAK MoO</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            Kami mengundang petani, peternak, dan pelaku usaha untuk bergabung 
            dalam ekosistem PAK MoO yang saling menguntungkan.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-12 lg:mb-16">
          <div>
            <img className="w-full h-64 sm:h-80 md:h-[420px] lg:h-[500px] object-cover rounded-2xl shadow-xl" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/01b21bcf78-c7af6ca7fd757dbf5cda.png" alt="Indonesian farmers shaking hands in partnership agreement, successful collaboration in agriculture" />
          </div>
          <div className="space-y-6 sm:space-y-8">
            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
              <div className="flex items-center mb-3 sm:mb-4">
                <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mr-4">
                  <i className="fa-solid fa-seedling"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-primary">Mitra Petani</h3>
              </div>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base mb-4">
                Program kemitraan untuk petani dengan jaminan pembelian hasil panen, 
                pembinaan teknis, dan bantuan modal usaha.
              </p>
              <div className="space-y-2">
                <div className="flex items-center text-sm text-gray-600">
                  <i className="fa-solid fa-check text-accent mr-2"></i>
                  Kontrak jangka panjang
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="fa-solid fa-check text-accent mr-2"></i>
                  Harga yang adil dan transparan
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="fa-solid fa-check text-accent mr-2"></i>
                  Pelatihan dan pendampingan
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
              <div className="flex items-center mb-3 sm:mb-4">
                <div className="w-12 h-12 bg-secondary text-white rounded-full flex items-center justify-center mr-4">
                  <i className="fa-solid fa-cow"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-primary">Mitra Peternak</h3>
              </div>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base mb-4">
                Kemitraan dengan peternak untuk pengembangan peternakan modern 
                dengan standar kualitas internasional.
              </p>
              <div className="space-y-2">
                <div className="flex items-center text-sm text-gray-600">
                  <i className="fa-solid fa-check text-accent mr-2"></i>
                  Bantuan teknologi peternakan
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="fa-solid fa-check text-accent mr-2"></i>
                  Akses ke pasar yang lebih luas
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="fa-solid fa-check text-accent mr-2"></i>
                  Program bagi hasil yang adil
                </div>
              </div>
            </div>

            <button className="w-full bg-accent text-primary py-3 sm:py-4 rounded-xl font-semibold text-base sm:text-lg hover:bg-yellow-400 transition-colors">
              Daftar Menjadi Mitra
            </button>
          </div>
        </div>

        <div className="bg-gradient-to-r from-primary to-secondary rounded-3xl p-8 sm:p-10 lg:p-12 text-white">
          <div className="text-center mb-8 sm:mb-12">
            <h3 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">Keuntungan Menjadi Mitra PAK MoO</h3>
            <p className="text-base sm:text-lg md:text-xl text-gray-200 max-w-2xl mx-auto px-2">
              Bergabunglah dengan jaringan mitra yang telah merasakan manfaat nyata
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className={`fa-solid ${benefit.icon} text-xl sm:text-2xl`}></i>
                </div>
                <h4 className="text-lg sm:text-xl font-bold mb-1 sm:mb-2">{benefit.title}</h4>
                <p className="text-gray-200 text-sm sm:text-base">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partnership;

